import styled from 'styled-components';

import { gridSizes, media } from 'utils/style';

import AddressDeleteModal from 'components/AddressDeleteModal/component';

export default styled(AddressDeleteModal)`
  padding: ${gridSizes('L')};

  ${media.lessThan('extraSmall')`
    padding: ${gridSizes('M')};
    display: flex;
    flex-direction: column;
    flex: 1;
    background: #fff;
  `};
  padding-bottom: 0px;

  .cancel-btn {
    margin-left: 12px;
    button {
      background-color: #ffe0e2;
      color: #cc000a;

      &:hover {
        background-color: #fdafb3;
      }
    }
  }

  .title {
    margin: 0;
  }
  p {
    margin: 0;
  }

  .button-container {
    display: flex;
    flex-direction: row;
    flex-direction: row;
    display: flex;
    justify-content: flex-end;
    padding: 12px 0px;
  }
`;
